import React from 'react';
import { Instagram, Youtube, Twitter, Linkedin } from 'lucide-react';
import './FooterBanner.css';

export default function FooterBanner() {
  return (
    <footer className="footer-banner" id="footer-contact">
      <div className="footer-grid">
        <div className="footer-brand">
          <div className="footer-logo-wrap">
            <div className="footer-logo">HG</div>
            <div className="footer-brand-name">HardwareGenie</div>
          </div>
          <p className="footer-desc">
            AI-powered hardware planner for finding electronics components across India.
          </p>
          <div className="footer-social">
            <a href="https://www.instagram.com/_aritra_006/" target="_blank" rel="noreferrer" aria-label="Instagram"><Instagram size={18} /></a>
            <a href="https://youtube.com" target="_blank" rel="noreferrer" aria-label="YouTube"><Youtube size={18} /></a>
            <a href="https://x.com" target="_blank" rel="noreferrer" aria-label="X"><Twitter size={18} /></a>
            <a href="https://www.linkedin.com/in/aritra-banik-565128323/" target="_blank" rel="noreferrer" aria-label="LinkedIn"><Linkedin size={18} /></a>
          </div>
        </div>

        <div className="footer-col">
          <h4>PRODUCT</h4>
          <a href="#how">Features</a>
          <a href="#how">How It Works</a>
          <a href="#how">Stores</a>
        </div>

        <div className="footer-col">
          <h4>SUPPORT</h4>
          <a href="#footer-contact">FAQs</a>
          <a href="mailto:araritra2006@gmail.com">Contact</a>
          <a href="mailto:araritra2006@gmail.com">araritra2006@gmail.com</a>
        </div>

        <div className="footer-col">
          <h4>LEGAL</h4>
          <a href="/privacy.html">Privacy</a>
          <a href="/terms.html">Terms</a>
          <a href="/cookies.html">Cookies</a>
        </div>
      </div>

      <div className="footer-bottom">
        <div>(c) 2026 HardwareGenie. All rights reserved.</div>
        <div className="footer-credit">Developed and maintained by Aritra Banik</div>
      </div>
    </footer>
  );
}

